import Layout from "@components/Layout"
import Spinner from "@components/Spinner"
import { useEffect } from "react"
import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"

export default function BuildingPlanPage() {
  const navigate = useNavigate()
  const { t } = useTranslation()

  useEffect(() => {
    const timeout = setTimeout(() => {
      navigate("/checkout/plans")
    }, 5000)

    return () => clearTimeout(timeout)
  }, [navigate])

  return (
    <Layout>
      <div className="shrink-0">
        <h1 className="text-2xl font-bold">
          {t("pages.onboarding.buildingPlan.heading")}
        </h1>
      </div>

      <div className="flex grow items-center">
        <div className="mx-auto w-2/3 space-y-9 rounded-xl bg-black px-9 py-20 text-white shadow-[0_25px_30px_-10px_rgba(38,57,77,0.6)]">
          <div className="flex justify-center">
            <Spinner color="white" />
          </div>

          <p className="text-center text-2xl font-bold">
            {t("pages.onboarding.buildingPlan.cardText")}
          </p>
        </div>
      </div>
    </Layout>
  )
}
